import React from "react";

import "./input-area.css";

const InputArea = ({
  type = "number",
  value,
  setValue = () => {},
  id = "",
}) => {
  return (
    <input
      className="input-area-component"
      id={id}
      type={type}
      value={value}
      onChange={(event) => {
        setValue(event.target.value);
      }}
    />
  );
};

export default InputArea;
